import { useRef } from "react"
import { Link } from "react-router-dom"
import { useForm, ValidationError } from "@formspree/react"

function Contact() {
  const [state, handleSubmit] = useForm("mwvgaqka")

  const formRef = useRef(null)

  const closeConfirmationModal = () => {
    window.location.reload()
  }

  return (
    <div id="contactBackground">
      {state.succeeded ? (
        <div id="confirmationContainer">
          <div className="closeButtonContainer">
            <button
              className="modalButton"
              onClick={closeConfirmationModal}
            >
              X
            </button>
          </div>
          <p className="confirmationP">
            Thank you for reaching out!
            <br />
            <br />
            We'll get back to you as soon as possible.
            <br />
            <br />
            Please allow between 48 - 72 hours for a response.
          </p>
        </div>
      ) : (
        <>
          <Link
            className="homeLink"
            to="/"
            title="Home Page"
            target="_blank"
          >
            <div id="contactNavBar">
              <img
                src="/certforcep.webp"
                alt="Certforce Logo"
                className="logo"
              ></img>
            </div>
          </Link>
          <div id="contactContainer">
            <header className="header">
              <h1 id="title" className="text-center">
                Get In Touch
              </h1>
              <p id="description" className="text-center">
                Thank you for taking the time to reach out!
              </p>
            </header>
            <form id="survey-form" onSubmit={handleSubmit} ref={formRef}>
              <div className="form-group">
                <label id="name-label">Name: </label>
                <input
                  id="name"
                  type="text"
                  name="name"
                  required
                />
                <ValidationError field="name" errors={state.errors} />
              </div>
              <div className="form-group">
                <label id="email-label">Email: </label>
                <input
                  id="email"
                  type="email"
                  name="email"
                  required
                />
                <ValidationError field="email" errors={state.errors} />
              </div>

              <div className="form-group">
                <p className="p-question">
                  Which option best describes your reason for getting in
                  touch?
                </p>
                <select
                  className="dropdown"
                  name="subject"
                  required
                >
                  <option value="" disabled selected hidden>
                    Select your interest
                  </option>
                  <option value="Constructive Feedback">
                    Constructive Feedback
                  </option>
                  <option value="Advertise Here">Advertise Here</option>
                  <option value="Ridiculous Comment">
                    Ridiculous Comment
                  </option>
                  <option value="Other">Other</option>
                </select>
                <ValidationError field="subject" errors={state.errors} />
              </div>

              <div className="form-group">
                <p className="p-comment">Please add your message:</p>
                <textarea
                  id="comments"
                  className="input-textarea"
                  name="message"
                  required
                ></textarea>
                <ValidationError field="message" errors={state.errors} />
              </div>
              {state.errors && state.errors.length > 0 && !state.errors[0].field && (
                <p className="submitError">
                  Something went wrong. Please try again.
                </p>
              )}
              <div className="form-button-container">
                <button
                  id="submit"
                  type="submit"
                  className="submit-button"
                  disabled={state.submitting}
                >
                  {state.submitting ? "SENDING..." : "SUBMIT"}
                </button>
              </div>
            </form>
          </div>
        </>
      )}
    </div>
  )
}
export default Contact
